import { render, staticRenderFns } from "./shift-followups.vue?vue&type=template&id=75e3ef9a&"
import script from "./shift-followups.vue?vue&type=script&lang=js&"
export * from "./shift-followups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports